import { SELECIONAR_VEICULO_ITINERARIO } from '../types'

export default function selecionarVeiculoItinerario (veiculo) {
  return {
    type: SELECIONAR_VEICULO_ITINERARIO,
    payload: veiculo
  }
}
